import { gql } from "@apollo/client";

export const GET_COMMODITIES = gql`
  query getItems($args: SearchItemsArgs!) {
    commodities(args: $args) {
      items {
        id
        name
        createdAt
        measurementUnit
        categories
        imageURL
        retail
        wholeSale
        requests {
          id
        }
        status
        user {
          name
          establishment {
            name
          }
        }
        retailPrices {
          id
          price
          latest
          createdAt
        }
        wholeSalePrices {
          id
          price
          latest
          createdAt
        }
      }
      meta {
        page
        count
        to
        total
        lastPage
      }
    }
  }
`;

export const GET_REQUESTS = gql`
  query getRequests($args: SearchRequestArgs!) {
    requests(args: $args) {
      items {
        id
        createdAt
        commodity {
          id
          name
          imageURL
        }
      }
      meta {
        page
        count
        to
        total
        lastPage
      }
    }
  }
`;
